module.exports = __webpack_public_path__ + "img/scratch-1-1.5b77a705.png";